import { render, staticRenderFns } from "./SubscribeHero.vue?vue&type=template&id=53e6d59a&scoped=true&"
import script from "./SubscribeHero.vue?vue&type=script&lang=js&"
export * from "./SubscribeHero.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeHero.vue?vue&type=style&index=0&id=53e6d59a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6d59a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeHero2026Stats: require('/opt/render/project/src/channels2022/src/components/subscribe2026/SubscribeHero2026Stats.vue').default,SubscribeStats: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeStats.vue').default,SubscribePrice: require('/opt/render/project/src/channels2022/src/components/subscribe/price/SubscribePrice.vue').default,SubscribeHeroBanner: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeHeroBanner.vue').default})
